import {
    CheckHomeworkMaxTextLength,
    CheckHomeworkPictureIcon, CheckHomeworkSaveButton,
    CheckHomeworkTextarea,
    CheckHomeworkСomment, CommentImage, CommentImageList
} from "./styles";
import PictureIcon from "../../icons/PictureIcon";
import {FC, useCallback, useEffect, useRef, useState} from "react";
import {API, Endpoints, TFile} from "@brg/api";
import {useProfile} from "@brg/auth";
import {FlexBox, useToasts} from "@brg/ui";
import {CommentHomeworkList} from "./commentHomeworkList";
import {useUppyLoader} from "../../hooks/useUppyLoader";
import CloseIcon from "../../icons/CloseIcon";
import {uploadValidator} from "../../helpers/utils/uploadValidator";

export const CommentHomework: FC<{postId: string}> = ({postId}) => {

    const fileRef = useRef();
    const [files, setFiles] = useState([]);
    const [time, setTime] = useState(Date.now());
    const [currentText, setCurrentText] = useState('');
    const element = useRef<HTMLTextAreaElement>(null)
    const toasts = useToasts()

    const profile = useProfile();

    // @ts-ignore
    const onUploadComplete = useCallback((uploadComplete) => {
        if (uploadComplete) {
            setFiles([])
        }
    }, [])

    // @ts-ignore
    const onAddImage = useCallback(async (e) => {

        const newFiles = Array.from(e.target.files) as TFile[];

        setTime(Date.now());

        let multipleFilesCheckResult: any = []
        if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
                newFiles.map(async (img: TFile) => {
                    return await uploadValidator([img], toasts, false, profile)
                })
            )
        }
        const allowed = await uploadValidator(files, toasts, false, profile)

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = ''
            return
        }

        setTimeout(() => {
            // @ts-ignore
            setFiles(prev => [...(prev || []), ...newFiles]);
        }, 0)
    } , [])

    // @ts-ignore
    const onRemoveImage = useCallback((id) => {
        setFiles(files?.filter((file: any) => file?.name!== id))
        setTime(Date.now())
    } , [files])

    const [uppy, data] = useUppyLoader( files, fileRef, onUploadComplete, time );
    const [t, setT] = useState(Date.now())

    const onSave = useCallback(() => {

        setCurrentText("")
        setFiles([])
        setTime(Date.now())

        API.request()
            .endpoint(Endpoints.gateway)
            .url(`message/api/comment/Add`)
            .post()
            .body({
                entityId: postId,
                entityType: "post",
                accountId: profile?.accountId,
                text: currentText,
                ...((data?.length > 0) ? { attachments: data?.map((file: any) => ({files: [{ fileId: file?.id }]})) } : {})
            })
            .release()
            .then((r) => r.json)
            .then((r) => {
                setTimeout(() => setT(Date.now()), 1000)
            })
    } , [currentText, postId, profile, data])

    const resize = useCallback(() => {

        if (!element?.current) return;

        element.current.style.height = "5px";
        element.current.style.height = (element.current.scrollHeight < 72 ? 72 : element.current.scrollHeight) +"px";
    }, [currentText, element.current?.scrollHeight]);

    useEffect(() => {
        resize()
    }, [resize])

    return <FlexBox direction="column" directionMobile="column" gy={24}>
        <CommentHomeworkList postId={postId} t={t}/>
        <CheckHomeworkСomment>
            <CheckHomeworkTextarea
                ref={element}
                placeholder={'Напишите комментарий студенту'}
                value={currentText}
                onChange={e => setCurrentText(e.target.value)}
                maxLength={800}
            />
            <CheckHomeworkPictureIcon>
                <PictureIcon
                    fill='#909090'
                />
                <input
                    type='file'
                    accept='image/jpeg, image/gif, image/png'
                    multiple={true}
                    /*@ts-ignore*/
                    ref={fileRef}
                    onChange={(e) => {
                        onAddImage(e)
                    }}
                />
            </CheckHomeworkPictureIcon>
            <CommentImageList>
                {data?.map((item: any, index: number) => item?.src && <FlexBox gx={16}>
                    <CommentImage src={item?.src} alt='big' key={index} />
                    <CloseIcon onClick={() => onRemoveImage(item?.name)}/>
                </FlexBox>)}
            </CommentImageList>
            <CheckHomeworkMaxTextLength>{currentText?.length}/800</CheckHomeworkMaxTextLength>
        </CheckHomeworkСomment>
        <CheckHomeworkSaveButton onClick={onSave}>Сохранить</CheckHomeworkSaveButton>
    </FlexBox>
}import {
    CheckHomeworkMaxTextLength,
    CheckHomeworkPictureIcon, CheckHomeworkSaveButton,
    CheckHomeworkTextarea,
    CheckHomeworkСomment, CommentImage, CommentImageList
} from "./styles";
import PictureIcon from "../../icons/PictureIcon";
import {FC, useCallback, useEffect, useRef, useState} from "react";
import {API, Endpoints, TFile} from "@brg/api";
import {useProfile} from "@brg/auth";
import {FlexBox, useToasts} from "@brg/ui";
import {CommentHomeworkList} from "./commentHomeworkList";
import {useUppyLoader} from "../../hooks/useUppyLoader";
import CloseIcon from "../../icons/CloseIcon";
import {uploadValidator} from "../../helpers/utils/uploadValidator";

export const CommentHomework: FC<{postId: string}> = ({postId}) => {

    const fileRef = useRef();
    const [files, setFiles] = useState([]);
    const [time, setTime] = useState(Date.now());
    const [currentText, setCurrentText] = useState('');
    const element = useRef<HTMLTextAreaElement>(null)
    const toasts = useToasts()

    const profile = useProfile();

    // @ts-ignore
    const onUploadComplete = useCallback((uploadComplete) => {
        if (uploadComplete) {
            setFiles([])
        }
    }, [])

    // @ts-ignore
    const onAddImage = useCallback(async (e) => {

        const newFiles = Array.from(e.target.files) as TFile[];

        setTime(Date.now());

        let multipleFilesCheckResult: any = []
        if (newFiles?.length > 0) {
            multipleFilesCheckResult = await Promise.all(
                newFiles.map(async (img: TFile) => {
                    return await uploadValidator([img], toasts, false, profile)
                })
            )
        }
        const allowed = await uploadValidator(files, toasts, false, profile)

        if (!allowed || multipleFilesCheckResult?.includes(false)) {
            e.target.value = ''
            return
        }

        setTimeout(() => {
            // @ts-ignore
            setFiles(prev => [...(prev || []), ...newFiles]);
        }, 0)
    } , [])

    // @ts-ignore
    const onRemoveImage = useCallback((id) => {
        setFiles(files?.filter((file: any) => file?.name!== id))
        setTime(Date.now())
    } , [files])

    const [uppy, data] = useUppyLoader( files, fileRef, onUploadComplete, time );
    const [t, setT] = useState(Date.now())

    const onSave = useCallback(() => {

        setCurrentText("")
        setFiles([])
        setTime(Date.now())

        API.request()
            .endpoint(Endpoints.gateway)
            .url(`message/api/comment/Add`)
            .post()
            .body({
                entityId: postId,
                entityType: "post",
                accountId: profile?.accountId,
                text: currentText,
                ...((data?.length > 0) ? { attachments: data?.map((file: any) => ({files: [{ fileId: file?.id }]})) } : {})
            })
            .release()
            .then((r) => r.json)
            .then((r) => {
                setTimeout(() => setT(Date.now()), 1000)
            })
    } , [currentText, postId, profile, data])

    const resize = useCallback(() => {

        if (!element?.current) return;

        element.current.style.height = "5px";
        element.current.style.height = (element.current.scrollHeight < 72 ? 72 : element.current.scrollHeight) +"px";
    }, [currentText, element.current?.scrollHeight]);

    useEffect(() => {
        resize()
    }, [resize])

    return <FlexBox direction="column" directionMobile="column" gy={24}>
        <CommentHomeworkList postId={postId} t={t}/>
        <CheckHomeworkСomment>
            <CheckHomeworkTextarea
                ref={element}
                placeholder={'Напишите комментарий студенту'}
                value={currentText}
                onChange={e => setCurrentText(e.target.value)}
                maxLength={800}
            />
            <CheckHomeworkPictureIcon>
                <PictureIcon
                    fill='#909090'
                />
                <input
                    type='file'
                    accept='image/jpeg, image/gif, image/png'
                    multiple={true}
                    /*@ts-ignore*/
                    ref={fileRef}
                    onChange={(e) => {
                        onAddImage(e)
                    }}
                />
            </CheckHomeworkPictureIcon>
            <CommentImageList>
                {data?.map((item: any, index: number) => item?.src && <FlexBox gx={16}>
                    <CommentImage src={item?.src} alt='big' key={index} />
                    <CloseIcon onClick={() => onRemoveImage(item?.name)}/>
                </FlexBox>)}
            </CommentImageList>
            <CheckHomeworkMaxTextLength>{currentText?.length}/800</CheckHomeworkMaxTextLength>
        </CheckHomeworkСomment>
        <CheckHomeworkSaveButton onClick={onSave}>Сохранить</CheckHomeworkSaveButton>
    </FlexBox>
}